import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BLOG_TAGS = ["All", "News", "Health Warnings", "Health Advice"];
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router";
import { Search } from "semantic-ui-react";
import { BLOG_URL_ROOT } from "../../../constants";
import { useBlogContext } from "../context/BlogContext";
export const BlogNavigation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { selectedTag, setSelectedTag, availableTags } = useBlogContext();
    const visibleTags = availableTags !== null && availableTags !== void 0 ? availableTags : BLOG_TAGS.slice(0, 1);
    const isOnPost = new RegExp(`\\/${BLOG_URL_ROOT}\\/`).test(location.pathname) && location.pathname.split("/").length > 1;
    const directoryPath = location.pathname.split("/").slice(0, 2).join("/");
    const [searchInput, setSearchInput] = useState(searchParams.get("search") || "");
    useEffect(() => {
        setSearchInput(searchParams.get("search") || "");
    }, [searchParams.get("search")]);
    const handleSearch = (e) => {
        e.preventDefault();
        const term = searchInput.trim();
        const params = new URLSearchParams();
        if (term)
            params.set("search", term);
        const basePath = isOnPost ? directoryPath : location.pathname.replace(/\/$/, "");
        navigate(`${basePath}${params.toString() ? `?${params.toString()}` : ""}`);
    };
    return (_jsx("div", { className: "bg-is2-blue width-full p-4", children: _jsxs("div", { className: "max-w-[1124px] m-auto flex flex-col md:flex-row items-center justify-between gap-4", children: [isOnPost
                    ? _jsx("span", { className: "!text-white text-2xl font-medium whitespace-nowrap", children: "Health Hub" })
                    : _jsx("h1", { className: "!text-white text-2xl font-medium whitespace-nowrap mb-0 pb-0", children: "Health Hub" }), _jsxs("div", { className: "w-full flex flex-col md:flex-row md:justify-end items-center gap-4", children: [_jsx("div", { className: "max-w-full flex overflow-x-auto no-scrollbar", children: visibleTags.map(tag => {
                                const tagParam = tag === "All" ? "" : `?tag=${encodeURIComponent(tag)}`;
                                const to = isOnPost
                                    ? `${directoryPath}${tagParam}`
                                    : `${location.pathname.replace(/\/$/, "")}${tagParam}`;
                                return (_jsx(Link, { to: to, className: `p-2 transition-colors text-white whitespace-nowrap ${selectedTag === tag ? "underline font-medium" : " hover:bg-white/20"}`, onClick: () => setSelectedTag(tag), children: tag }, tag));
                            }) }), _jsx("form", { onSubmit: handleSearch, children: _jsx(Search, { size: "small", open: false, input: { autoComplete: "off", iconPosition: "left" }, onSearchChange: (_, { value }) => setSearchInput(value !== null && value !== void 0 ? value : ""), value: searchInput, placeholder: "Search articles..." }) })] })] }) }));
};
